// reveal image
import toArray from '@/scripts/utils/get-elements-array';
import ScrollMagic from 'scrollmagic';
import Controller from '@/scripts/utils/scrollmagic/controller';
import './reveal-images.scss';

document.addEventListener('DOMContentLoaded', () => {
  const revealImages = toArray('[data-role*="reveal-image-wrapper"]');
  revealImages.forEach((wrapper) => {
    const $overlay = $('<div class="reveal-image__overlay"/>');
    $(wrapper)
      .addClass('reveal-image')
      .find('[data-role*="reveal-image-container"]')
      .addClass('reveal-image__container')
      .append($overlay)
      .find('[data-role="reveal-image-target"]')
      .addClass('reveal-image__target');
    return new ScrollMagic.Scene({
      triggerElement: wrapper,
      triggerHook: 'onEnter',
      offset: 150,
      reverse: false,
    })
      .on('start', () => {
        $(wrapper).addClass('is-loaded');
      })
      .addTo(Controller);
  });
  return true;
});




// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/reveal-images/reveal-images.js